import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.707 2.76a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473a10.014 10.014 0 003.308-4.82c-1.274-4.057-5.064-7-9.542-7a9.958 9.958 0 00-4.512 1.074l-1.78-1.78h-.001zm4.26 4.26l1.515 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
        fill="#506176"
      />
      <path
        d="M12.454 17.164L9.75 14.46a4 4 0 01-3.742-3.74L2.335 7.044a9.98 9.98 0 00-1.877 3.422c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
        fill="#506176"
      />
    </svg>
  );
}

export default SvgComponent;
